import rg4js from "raygun4js";
import { User } from "../../models/user";
export const RAYGUN_API_KEY = "FtWwu6wu6S5iQA3I7c0N0w";
export const setRaygunUser = (user: User) => {
	rg4js("setUser", {
		identifier: user.subject,
		isAnonymous: false,
		email: user.email,
		firstName: user.firstname,
		fullName: user.name,
		uuid: user.subject,
	});
};
